import httpClient from "@/services/base.service.js";

export default {
  getAll: function () {
    return httpClient.get("/api/v1/businesscategory/get");
  }
};
